import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import _isNaN from 'lodash/isNaN';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
  FormLabel,
} from '@one-thd/sui-atomic-components';
import { useIsMobile } from '../ProjectLocation/helpers';
import InputStairs from './inputStairs';

import { updateSteps, confirmSteps, addSteps, editSteps } from '../../actions/stepsAction';
import { selectSelectedCarpetChoice } from '../../selectors/pricing';
import { stepsSelector } from '../../selectors/steps/steps';
import { useEditStepModal } from '../stairCardModal/useEditStepModal';
import { InputWrapper, Form } from './styles';

function Steps(props) {
  const { showModal, handleClose, isEdit } = props;
  const selectedChoice = useSelector(selectSelectedCarpetChoice);
  const carpetPrice = selectedChoice?.priceSquareYard || selectedChoice;
  const stepsRef = useRef({});
  const dispatch = useDispatch();
  const [showError, setShowError] = useState(false);
  const { isAdd, steps } = useSelector(stepsSelector);

  const isMobile = useIsMobile();
  const modalRef = useRef();
  useEditStepModal(isEdit, steps);

  const cancelSteps = () => {
    handleClose();
    if (isEdit) {
      dispatch(editSteps(false));
    } else if (isAdd) {
      dispatch(addSteps(false));
    }
    dispatch(confirmSteps(true));
  };

  const dispatchSteps = (e) => {
    const inputSteps = stepsRef.current.numberofsteps;
    if (inputSteps.value === '') {
      setShowError(true);
      e.preventDefault();
    } else {
      dispatch(updateSteps(Number(inputSteps.value), carpetPrice));
      if (isAdd) {
        dispatch(addSteps(false));
      } else if (isEdit) {
        dispatch(editSteps(false));
      }
      dispatch(confirmSteps(true));
    }
    handleClose();
  };
  return (
    <>
      <div>
        <Modal size="sm" open={showModal} onClose={cancelSteps} ref={modalRef}>
          <ModalHeader onClose={cancelSteps}>
            <Typography variant="h4" weight="bold" style={{ marginBottom: '1.6rem' }}>
              {!isEdit ? 'Add Stairs' : 'Edit Stairs'}
            </Typography>
          </ModalHeader>
          <ModalBody style={{ width: '100%' }}>
            <Form>
              <InputWrapper>
                <FormLabel htmlFor="numberOfStep">Number of Steps</FormLabel>
                <InputStairs
                  id="step_number"
                  inputName="numberofsteps"
                  placeholder="ex. 6"
                  errorText="This field is required"
                  forwardedRef={stepsRef}
                  showError={showError}
                  value={isEdit ? steps : undefined}
                />
              </InputWrapper>
            </Form>
          </ModalBody>
          <ModalFooter position="end">
            <ButtonGroup
              orientation={isMobile ? 'vertical' : 'horizontal'}
              variant={isMobile ? 'primary' : 'secondary'}
            >
              <Button variant="secondary" style={{ display: isMobile && 'none' }} onClick={cancelSteps}>Cancel
              </Button>
              <Button
                variant="primary"
                onClick={(event) => dispatchSteps(event)}
              >
                {!isEdit ? 'Add Stairs' : 'Update Stairs'}
              </Button>

              <Button
                variant="secondary"
                onClick={cancelSteps}
                style={{ display: !isMobile && 'none' }}
              >Cancel
              </Button>

            </ButtonGroup>
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
}

Steps.propTypes = {
  showModal: PropTypes.bool,
  isEdit: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
};

Steps.defaultProps = {
  showModal: false,
  isEdit: false,
};

export default Steps;
